import React from 'react';
import './contact-us-screen.scss';
import { SignUpContainer } from '../sign-up-container/sign-up-container';
import { SVGS } from '../assets';

export const ContactUsScreen: React.FC = () => {
  return (
    <SignUpContainer customClass="contact-us-screen-wrapper">
      <div className="contact-us-screen">
        <img
          src={SVGS.SuccessTick}
          alt=""
          className="contact-us-screen-image"
        />
        <div className="contact-us-screen-text">
          <span className="contact-us-screen-text-heading primary-font-bold">
            Thank You
          </span>
          <span className="contact-us-screen-text-subheading">
            We've received your request for the{' '}
            <span className="primary-font-bold">Enterprise Plan</span>
            <br />
            Our team will reach out soon to discuss your needs and share a
            custom quote.
          </span>
        </div>
        <span className="contact-us-screen-footer">
          For query reach us at <a href="">hi@zotok.ai</a>
        </span>
      </div>
    </SignUpContainer>
  );
};
